// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2WCpF","location":"Header_location__2oBzD"};